import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import LatestVersionDownloadButton from 'components/project/download/components/LatestVersionDownloadButton';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <LatestVersionDownloadButton {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}
